import {MenuItemIcon} from '@models/sidebar/menu-item-icon';
import {MenuItemType} from '@models/sidebar/menu-item-type';

export class MenuItemParentDetails {
  machineCategory: string = '';
  organizationId: number = -1;
  name: string = '';
  id: string = '';
  label: string = '';
  type: MenuItemType = MenuItemType.NONE;
  icon: MenuItemIcon = MenuItemIcon.NONE;
}
